import { get, post } from './axios.js'

/**
 * 알람 상세 조회 - /alarm/alarmSelect
 * @param {object} params
 * @property {string} params.sales_id
 * @returns
 */
export async function alarmSelect(params = {}) {
  try {
    const result = await post('/alarm/alarmSelect', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 알람 등록/수정 - /alarm/alarmEdit
 * @param {object} params
 * @property {string} params.sales_id
 * @property {string} params.alarm_seq - 알람 seq
 * @property {string} params.sales_id - 영업기회 ID 
 * @property {string} params.w_alarm_prd - Warranty 알람주기 
 * @property {string} params.w_alarm_cyc - Warranty 되풀이 주기(매월 선택시에만 적용됨)  
 * @property {string} params.w_alarm_week - Warranty 되풀이 요일(매주 선택시에만 적용됨)  
 * @property {string} params.w_start_dt - Warranty 알람시작일
 * @property {string} params.w_end_dt - Warranty 알람종료일
 * @property {string} params.w_end_cnt - Warranty 다음 되풀이 후 종료됨 (기준횟수)
 * @property {string} params.w_alarm_year - Warranty 알람발송년월일(매년 선택시에만 적용됨)
 * @property {string} params.w_end_ck - Warranty 1:종료날짜,2:되풀이, 3:종료날짜 없음
 * @property {string} params.w_enable_yn - Warranty 알람기능 활성여부 
 * @property {string} params.p_alarm_prd - 지급일 알람주기
 * @property {string} params.p_alarm_cyc - 지급일 매 주기
 * @property {string} params.p_alarm_week - 지급일 되풀이 요일(매주 선택시에만 적용됨)  
 * @property {string} params.p_start_dt - 지급일 알람시작일
 * @property {string} params.p_end_dt - 지급일 알람종료일
 * @property {string} params.p_end_cnt - 지급일 다음 되풀이후 종료됨 (기준횟수)
 * @property {string} params.p_alarm_year - 지급일 알람발송년월일(매년 선택시에만 적용됨)
 * @property {string} params.p_end_ck - 지급일 1:종료날짜,2:되풀이, 3:종료날짜 없음
 * @property {string} params.p_enable_yn - 지급일 알람기능 활성여부 
 * @returns
 */
export async function alarmEdit(params = {}) {
  try {
    const result = await post('/alarm/alarmEdit', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 알람 조회 - /alarm/alarmList
 * @param {object} params
 * @property {string} params.end_user_nm
 * @property {string} params.out_sales_nm
 * @property {string} params.start_dt
 * @property {string} params.end_dt
 * @property {string} params.stage_cd
 * @returns
 */
export async function alarmList(params = {}) {
  try {
    const result = await post('/alarm/alarmList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 알람 목록 조회 - /alarm/myAlarmList
 * @param {object} params
 * @property {string} params.page_count
 * @property {string} params.out_sales_nm
 * @property {string} params.start_dt
 * @property {string} params.end_dt
 * @property {string} params.stage_cd
 * @returns
 */
export async function myAlarmList(params = {}) {
  try {
    const result = await post('/alarm/myAlarmList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 알람 edit - /alarm/myAlarmEdit
 * @param {object} params
 * @property {string} params.al_seq
 * @property {string} params.del_yn
 * @property {string} params.ss_user_id - 아이디
 * @returns
 */
export async function myAlarmEdit(params = {}) {
  try {
    const result = await post('/alarm/myAlarmEdit', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 알람 edit - /alarm/myAlarmReadEdit
 * @param {object} params
 * @property {string} params.al_seq
 * @property {string} params.del_yn
 * @property {string} params.ss_user_id - 아이디
 * @returns
 */
export async function myAlarmReadEdit(params = {}) {
  try {
    const result = await post('/alarm/myAlarmReadEdit', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 알람 edit - /alarm/salesCheck
 * @param {object} params
 * @property {string} params.sales_id
 * @returns
 */
export async function salesCheck(params = {}) {
  try {
    const result = await post('/alarm/salesCheck', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}